import { Capacitor } from '@capacitor/core';
import { StatusBar, Style } from '@capacitor/status-bar';

const BRAND_COLOR = '#064E3B';

export async function initNativeUI() {
  if (!Capacitor.isNativePlatform()) return;
  try {
    await StatusBar.setOverlaysWebView({ overlay: false });
    await StatusBar.setBackgroundColor({ color: BRAND_COLOR });
    await StatusBar.setStyle({ style: Style.Dark });
  } catch (e) {
    console.log('StatusBar init skipped:', e?.message);
  }
}
